import React from "react";
import EntityForm from "modules/entity/forms";
import Form from "./Form";
import get from "lodash/get";
import useTranslation from "../../../hooks/useTranslation";

const Update = ({ closeUpdateModal, loadItems, selected }) => {
  const { tr } = useTranslation();

  return (
    <EntityForm.Default
      method="put"
      url={`/categories/${get(selected, "id")}`}
      onSuccess={(data, resetForm) => {
        resetForm();
        closeUpdateModal();
        loadItems();
      }}
      fields={[
        {
          name: "name",
          required: true,
          value: get(selected, "name"),
        },
        {
          name: "type",
          required: true,
          value: get(selected, "type"),
        },
        {
          name: "status",
          value: get(selected, "status") === 1,
          onSubmitValue: (value) => (value ? 1 : 0),
        },
        {
          name: "sort",
          type: "number",
          value: get(selected, "sort"),
        },
        {
          name: "file_id",
          value: get(selected, "file") ? selected.file : null,
          onSubmitValue: (value) => (value ? value.id : null),
        },
      ]}
    >
      {({ isSubmitting, values, setFieldValue }) => {
        return (
          <div>
            <div className="modal-title">
              {tr("Изменить категория продукта")}
            </div>
            <div className="modal-body">
              <Form
                {...{ isSubmitting, values, setFieldValue, isUpdate: true }}
              />
            </div>
          </div>
        );
      }}
    </EntityForm.Default>
  );
};

export default Update;
